import { Box } from 'components/Box';
import { CmsAmpCardsBlockCard } from 'modules/cms/blocks/Amp/Cards';
import { gutterWidth } from 'theme/theme';

type Props = {
  layout: 'SLIM' | 'REGULAR';
};

export function CmsAmpRecommendedJobCard({ layout }: Props) {
  return (
    <Box
      // @ts-expect-error TS(2695): Left side of comma operator is unused and has no s... Remove this comment to see the full error message
      display={('block', null, 'inline-block')}
      width={[1, null, 1 / 3]}
      verticalAlign="top"
      maxWidth={320}
      px={[0, null, gutterWidth / 2]}
      py={[gutterWidth / 2, null, 0]}
    >
      <CmsAmpCardsBlockCard
        card={{
          image:
            layout === 'SLIM'
              ? undefined
              : {
                  filename: '{{logo.filename}}',
                  handle: '{{logo.handle}}',
                  mimetype: '{{logo.mimetype}}',
                  size: parseInt('{{logo.size}}', 10),
                  source: '{{logo.source}}',
                },
          headline: '{{name}}',
          text: '{{city}}, {{state}}',
          label: '{{orgName}}',
          urls: {
            en: '{{url.en}}',
            es: '{{url.es}}',
            pt: '{{url.pt}}',
          },
        }}
        imageSize="SMALL"
      />
    </Box>
  );
}
